import FeatherIcon from 'feather-icons-react';

interface OrderInfoItemProps {
  icon: string;
  label: string;
}

const OrderInfoItem = ({ icon, label }: OrderInfoItemProps) => {
  return (
    <div className="d-flex align-items-center">
      <FeatherIcon
        icon={icon}
        className="me-2"
        size={16}
        style={{ strokeWidth: '2.5' }}
      />
      <h5 className="fs-14 mb-0">{label}</h5>
    </div>
  );
};

export default OrderInfoItem;
